import PropTypes from 'prop-types';
import AssigneeType from './assignee';

const PTOType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  reason: PropTypes.string,
  assignee: AssigneeType,
  conflict: PropTypes.shape({ dates: PropTypes.arrayOf(PropTypes.string) }),
});

export default PTOType;



// WEBPACK FOOTER //
// ./client/app/shared/types/pto.js